/**
 *
 */
export class BasicConstants {
    public static COMPANY_NAME: string = "Goodgame Studios";


    public static readonly TARGET_FRAMERATE:number =24;

    //----------------------------------
    //	times
    //----------------------------------
    public static LOGGEDIN_MESSAGE_TIME_INTERVAL: number = 60000;
    public static POPUP_TIME_INTERVAL: number = 300000; // 5min
    /**
     * if fake loading progress will be shown, this will be the progressbar update time for each loop
     */
    public static AUTOMATIC_LOADING_BAR_UPDATE_TIME: number = 2000;
    /**
     * if file is smaller as max size, realtime loading progress will be shown, else fake progress will be shown
     */
    public static MAX_FILESIZE_REALTIMELOADING: number = 500000;
    /**
     * amount of available generic loading texts
     */
    public static NUM_RANDOM_LOADINGTEXT_ELEMENTS_AVAILABLE: number = 20;

    //----------------------------------
    //	domain parameters
    //----------------------------------
    public static DOMAIN_PROTOCOL: string = "https";
    public static DOMAIN_INTERNAL_DNS: string = "filetest.services.ggs-net.com";
    public static DOMAIN_INTERNAL_DNS_ALIAS: string = "filetest.ggs-hh.net";

    //----------------------------------
    //	url-var parameters
    //----------------------------------
    public static NETWORK_PARAMETER: string = "network";
    public static IS_TEST_PARAMETER: string = "IS_TEST";
    public static IS_LOCALE_PARAMETER: string = "IS_LOCALE";
    public static COUNTRY_PARAMETER: string = "country";
    public static PRE_CLIENT_PARAMETER: string = "PRE_CLIENT";
    public static FORCE_TO_SHOW_TEST_SERVERS: string = "forceToShowTestServers";
    public static USE_MIN_ASSETS: string = "useMinAssets";
    public static COMMAND_EMULATE_LAGGY_CLIENT: string = "emulateLaggyClient";
    public static LAGGY_CLIENT_MIN_DELAY: string = "laggyClientMinDelay";
    public static LAGGY_CLIENT_MAX_DELAY: string = "laggyClientMaxDelay";
    public static MAINTENANCE_PARAMETER: string = "maintenance";
    public static NETCONF_TEST_PARAMETER: string = "testNetConf";
    public static FORCE_TO_SHOW_LOGGER: string = "forceToShowLogger";
    public static FORCE_MANUAL_LOGIN: string = "forceManualLogin";
    public static IN_GAME_SHOP: string = "inGameShop";
    public static KEY_PARAMETER: string = "key";
    public static GENDER_PARAMETER: string = "gender";
    public static DISPLAY_NAME_PARAMETER: string = "displayName";

    public static PLN_PARAMETER: string = "pln";
    public static SIG_PARAMETER: string = "sig";
    public static SUK_PARAMETER: string = "suk";

    public static CACHE_PARAMETER: string = "cache";
    public static DISTRIBUTOR_ID_PARAMETER: string = "distributorId";
    public static VERSION_DATE_PARAMETER: string = "vD";
    public static GAME_ID_PARAMETER: string = "gameID";
    public static REFERRER_PARAMETER: string = "ref";
    public static NETWORK_ID: string = "networkID";
    public static PARTNER_WEBSITE: string = "w";
    public static LP_PARTNER_WEBSITE: string = "lpw";
    public static LOGIN_SOURCE: string = "ls";
    public static FIRST_LOADER_VERSION: string = "firstLoaderVersion";
    public static FRIEND_INVITE_CODE: string = "ic";

    //----------------------------------
    //	subloader
    //----------------------------------
    public static BASIC_FRAME_ONE_LOADER: string = "basicFrameOne";
    public static NETWORK_INFO_LOADER: string = "networkInfo";
    public static ZONE_CAPACITY_INFO_LOADER: string = "zoneCapacityInfo";
    public static LANGUAGE_PROP_LOADER: string = "langVersion";
    public static LANGUAGE_RES_LOADER: string = "languageXML";
    public static ITEM_XML_LOADER: string = "itemXML";
    public static ITEM_XML_VERSION: string = "itemXMLVersion";
    public static ACCOUNT_COOKIE_LOADER: string = "accountCookie";
    public static AB_CONFIG_LOADER: string = "AB_CONFIG_LOADER";
    public static GLOBAL_COOKIE_SAVER_LOADER: string = "GLOBAL_COOKIE_SAVER_LOADER";
    public static OLD_GLOBAL_COOKIE_SAVER_LOADER: string = "OLD_GLOBAL_COOKIE_SAVER_LOADER";
    public static LANDING_PAGE_COOKIE_SAVER_LOADER: string = "LANDING_PAGE_COOKIE_SAVER_LOADER";
    public static COUNTRY_CONFIG_LOADER: string = "countryConfigLoader";

    //----------------------------------
    //	loading queue end elements
    //----------------------------------
    public static PRE_ASSETS: string = "PRE_ASSETS";
    public static APP_LOADER: string = "APP_LOADER";

    //----------------------------------
    //	misc
    //----------------------------------
    public static CORE_TEST_FOLDER: string = "-coretest";
    public static CORE_DEV_FOLDER: string = "-coredev";
    public static TEST_FOLDER: string = "-test";
    public static LIVE_TEST_FOLDER: string = "-livetest";
    public static LOCA_TEST_FOLDER: string = "-locatest";
    public static USABILITYTEST_FOLDER: string = "-usability";
    public static PRECLIENT_FOLDER: string = "-preClient";
    public static DEV_TEST_FOLDER: string = "-dev";
    public static PRIVATE_TEST_SERVER_URL: string = "client1.test.ggs-of.net";
    public static LOCALE_URL: string = "file:";
    private static AGB_URL: string = BasicConstants.DOMAIN_PROTOCOL + "://www.goodgamestudios.com/terms_";
    public static GGS_DOMAIN: string = "goodgamestudios.com";
    public static LOCAL_HOST: string = "localhost";

    public static isLocalHost(url:string):boolean {
        return  url.indexOf(BasicConstants.LOCAL_HOST) != -1  ||  url.indexOf("0.0.0.0") != -1 ||   url.indexOf("127.0.0.1") != -1;
    }

    //----------------------------------
    //	Live Branching Test Environment
    //----------------------------------
    public static LIVE_BRANCHING_ENVIRONMENT: string = "Web_PreClient";

    //----------------------------------
    // languages
    //----------------------------------
    public static LANGUAGE_GERMAN: string = "de";
    public static LANGUAGE_ENGLISH: string = "en";

    public static LANGUAGE_ARABIC: string = "ar";
    public static LANGUAGE_CZECH: string = "cs";
    public static LANGUAGE_CHINESE_SIMPLE: string = "zh_CN";
    public static LANGUAGE_CHINESE_TRADITIONAL: string = "zh_TW";
    public static LANGUAGE_DANISH: string = "da";
    public static LANGUAGE_DUTCH: string = "nl";
    public static LANGUAGE_FINNISH: string = "fi";
    public static LANGUAGE_FRENCH: string = "fr";
    public static LANGUAGE_GREECE: string = "el";
    public static LANGUAGE_HUNGARIAN: string = "hu";
    public static LANGUAGE_ITALIAN: string = "it";
    public static LANGUAGE_JAPANESE: string = "ja";
    public static LANGUAGE_KOREAN: string = "ko";
    public static LANGUAGE_NORWEGIAN: string = "no";
    public static LANGUAGE_POLISH: string = "pl";
    public static LANGUAGE_PORTUGUESE: string = "pt";
    public static LANGUAGE_RUSSIAN: string = "ru";
    public static LANGUAGE_SPANISH: string = "es";
    public static LANGUAGE_SWEDISH: string = "sv";
    public static LANGUAGE_TURKISH: string = "tr";
    public static LANGUAGE_BULGARIAN: string = "bg";
    public static LANGUAGE_SLOVAKIAN: string = "sk";
    public static LANGUAGE_ROMANIAN: string = "ro";



    // TODO  HTML5 HTML-2128 WHAT DOES THAT MEAN - DO - USED FOR??  WHY WOULD BULGARIAN AND ROMANIAN   ***  NOT *** BE FLASHLANGUANGES ??
    public static isFlashLanguage(languange: string): boolean {
        if (!languange) {
            return false;
        }

        switch (languange) {
            case BasicConstants.LANGUAGE_GERMAN:
            case BasicConstants.LANGUAGE_ENGLISH:
            case BasicConstants.LANGUAGE_ARABIC:
            case BasicConstants.LANGUAGE_CZECH:
            case BasicConstants.LANGUAGE_CHINESE_SIMPLE:
            case BasicConstants.LANGUAGE_CHINESE_TRADITIONAL:
            case BasicConstants.LANGUAGE_DANISH:
            case BasicConstants.LANGUAGE_DUTCH:
            case BasicConstants.LANGUAGE_FINNISH:
            case BasicConstants.LANGUAGE_FRENCH:
            case BasicConstants.LANGUAGE_GREECE:
            case BasicConstants.LANGUAGE_HUNGARIAN:
            case BasicConstants.LANGUAGE_ITALIAN:
            case BasicConstants.LANGUAGE_JAPANESE:
            case BasicConstants.LANGUAGE_KOREAN:
            case BasicConstants.LANGUAGE_NORWEGIAN:
            case BasicConstants.LANGUAGE_POLISH:
            case BasicConstants.LANGUAGE_PORTUGUESE:
            case BasicConstants.LANGUAGE_RUSSIAN:
            case BasicConstants.LANGUAGE_SPANISH:
            case BasicConstants.LANGUAGE_SWEDISH:
            case BasicConstants.LANGUAGE_TURKISH:
            case BasicConstants.LANGUAGE_SLOVAKIAN:
                return true;

            default:
                return false;
        }
    }

    public static uniqueAgbLink(languange: string): string {
        return BasicConstants.AGB_URL + languange + "/#terms";
    }

    public static uniquePolicyLink(languange: string): string {
        return BasicConstants.AGB_URL + languange + "/#privacy";
    }

    //ID-CHECK Korea
    public static KOREA_INSTANCE_ID: number = 23;


    /**
     * In BigFarm FLAs TextField are referencing an alias that specificy which font has to be used.
     * That Alias is defined in the first FLA that is loaded by the Game and that embeds the necessary fonts
     *
     * unfortunately this is not true for Empire where they are just referencing everywhere the specific file - but we will figure out a possible solution
     * @type {string}
     */
    public static readonly FONT_ALIAS_HEADER :string = "_HeaderFont";
    public static readonly FONT_ALIAS_BODY :string = "_BodyFont";

}
